import {
  EditTournamentDropBox,
  EditTournamentDropBoxItemWrapper,
  EditTournamentDropBoxItem,
} from "./style";

export interface TournamentDropBoxProps {
  handleOpen?: () => void;
  value: any;
  setValue: (v: any) => void;
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  list: { value: any; name: string }[];
}

const TournamentDropBox = ({
  handleOpen,
  value,
  setValue,
  isOpen,
  setIsOpen,
  list,
}: TournamentDropBoxProps) => {
  const getName = (value: any) => {
    return list.find((l) => l.value === value)?.name || "";
  };

  const handleClick = () => {
    if (handleOpen) {
      handleOpen();
    } else {
      setIsOpen(!isOpen);
    }
  };

  return (
    <EditTournamentDropBox
      onClick={(e) => {
        e.stopPropagation();
        handleClick();
      }}
    >
      <div className="value">{getName(value)}</div>
      <span>
        <img src="/image-web/tournament/drop-down.svg" alt="drop-down" />
      </span>
      {isOpen && (
        <EditTournamentDropBoxItemWrapper>
          {list.map((t, i) => (
            <EditTournamentDropBoxItem
              key={i}
              onClick={() => {
                setValue(t.value);
                setIsOpen(false);
              }}
              selected={t.value === value}
            >
              {t.name}
              {value === t.value && (
                <img src="/image-web/tournament/check.svg" alt="check" />
              )}
            </EditTournamentDropBoxItem>
          ))}
        </EditTournamentDropBoxItemWrapper>
      )}
    </EditTournamentDropBox>
  );
};

export default TournamentDropBox;
